<template>
  <div class="mention-items">
    <SearchResults
      :results="items.result"
      :search-query="items.query"
      :is-grouped="false"
      :tab-select="true"
      :manually-displayed="true"
      @selectSearchResult="selectResult"
    />
    <div
      v-if="items.result.length === 0"
      class="item"
    >
      {{ translate('noResults') }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { Editor } from '@tiptap/core';
import { onMounted, onUnmounted, defineAsyncComponent } from 'vue';
import unifiedToEmoji from '@/utilities/unifiedToEmoji';

const SearchResults = defineAsyncComponent(
  () => import(/* webpackChunkName: "searchResults" */ '@/components/elements/SearchResults.vue')
);

const { items, editor, command } = defineProps<{
  items: { result: any[]; query: string };
  editor: Editor;
  command: CallableFunction;
}>();

onMounted(() => {
  editor.commands.setMentionDropdownActive(true);
});

onUnmounted(() => {
  editor.commands.setMentionDropdownActive(false);
});

function selectResult(result: any) {
  command(unifiedToEmoji(result.unified));
}
</script>
